import React from 'react';

import imgLogo from '../../assets/img/logo-square.svg';

function SimpleLayout({children, useNarrow = true}) {

    return (
        <>
            <div className="position-relative overflow-hidden min-vh-100 d-flex align-items-center justify-content-center">
                <div className="d-flex align-items-center justify-content-center w-100">
                    <div className="row justify-content-center w-100">
                        <div className={useNarrow ? 'col-md-8 col-lg-6 col-xxl-2' : 'col-lg-8 col-xxl-6'}>
                            <div className="card my-4">
                                <div className="card-body">
                                    <a href="/" className="text-nowrap logo-img text-center d-block mb-5 w-100">
                                        <img src={imgLogo} height="160" alt="logo" />
                                    </a>
                                    {children}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SimpleLayout;
